import type {
	VsmContext,
	PageConfigEntry,
	MasterPageConfigEntry,
	PageConfigFn,
	MasterPageConfigFn,
} from '@wix/thunderbolt-vsm-api-types'
import type { StickyToComponentPageConfig, StickyToComponentMasterPageConfig } from '../types'
import { name } from '../symbols'

const stickyToComponentPageConfig: PageConfigFn<StickyToComponentPageConfig> = (
	{ api }: VsmContext,
	pageId: string
) => {
	const pageData = api.page.getPageData(pageId)
	const isMasterPage = pageData ? api.page.isMasterPage(pageData) : false

	const hasStickyComps = api.components.hasComponentWithPredicate((_, compId) =>
		api.components.hasStickyToCompLayout(compId)
	)

	if (isMasterPage || !hasStickyComps) {
		return { shouldLoadPageFeature: false }
	}

	const headerSections = api.components.getComponentsByType('HeaderSection')
	const headerSectionEntries = Object.entries(headerSections)
	const headerSectionId = headerSectionEntries.length > 0 ? headerSectionEntries[0][0] : null

	const isHeaderSectionHasAnimationBehavior = headerSectionId
		? api.components.getAnimations(headerSectionId).length > 0
		: false

	return {
		shouldLoadPageFeature: true,
		pageConfig: { isHeaderSectionHasAnimationBehavior },
	}
}

const stickyToComponentMasterPageConfig: MasterPageConfigFn<StickyToComponentMasterPageConfig> = ({
	api,
}: VsmContext) => {
	const isResponsive = api.env.isResponsive()
	const isClassicHeaderFixed = !isResponsive && api.components.isCompFixed('SITE_HEADER')
	const isClassicHeaderAnimated = !isResponsive && api.components.getAnimations('SITE_HEADER').length > 0
	const shouldListenToTransitionEnd = isClassicHeaderFixed && isClassicHeaderAnimated

	return { shouldListenToTransitionEnd }
}

export const pageConfig: PageConfigEntry<StickyToComponentPageConfig> = {
	name,
	configFactory: stickyToComponentPageConfig,
	experiment: 'specs.thunderbolt.vsmPageConfigs',
}

export const masterPageConfig: MasterPageConfigEntry<StickyToComponentMasterPageConfig> = {
	name,
	configFactory: stickyToComponentMasterPageConfig,
	experiment: 'specs.thunderbolt.vsmPageConfigs',
}
